<template>
  <form @keyup.enter="search">
    <div class="page-heading">
      <h1 class="page-heading__title">
        Search bookings
      </h1>
    </div>
    <div class="container">
      <div class="row">
        <div
          id="select-airport"
          class="col-md-12 mb-4 mt-4"
        >
          <SelectAirport />
        </div>
      </div>

      <div class="section__group col-md-6 mb-3">
        <h6><strong>Find Booking</strong></h6>
        <div class="row">
          <div
            id="select-reference"
            class="col-md-6 mb-3"
          >
            <label class="sr-only">Reference / ID</label>
            <input
              v-model="bookingSearch.bookingReference"
              :disabled="searchInProgress"
              type="text"
              class="form-control"
              placeholder="Reference / ID"
            >
          </div>
        </div>

        <div class="row">
          <div
            id="select-reference"
            class="col-md-6 mb-3"
          >
            <label class="sr-only">3rd Party Reference</label>
            <input
              v-model="bookingSearch.thirdPartyBookingReference"
              :disabled="searchInProgress"
              type="text"
              class="form-control"
              placeholder="3rd Party Ref"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 mb-3">
            <label class="sr-only">Vehicle registration</label>
            <input
              v-model="bookingSearch.vehicleRegistration"
              :disabled="searchInProgress"
              type="text"
              class="form-control"
              placeholder="Vehicle registration"
            >
          </div>

          <div class="col-md-4 mb-3">
            <label class="sr-only">Email</label>
            <input
              v-model="bookingSearch.email"
              :class="{ 'is-invalid': $v.bookingSearch.email.$invalid}"
              :disabled="searchInProgress"
              type="email"
              class="form-control"
              placeholder="Email"
            >
          </div>

          <div class="col-md-4 mb-3">
            <label class="sr-only">Surname</label>
            <input
              v-model="bookingSearch.lastName"
              :disabled="searchInProgress"
              type="text"
              class="form-control"
              placeholder="Surname"
            >
          </div>

          <div class="col-md-4 mb-3">
            <label class="sr-only">Postcode</label>
            <input
              v-model="bookingSearch.postcode"
              :disabled="searchInProgress"
              type="text"
              class="form-control"
              placeholder="Postcode"
            >
          </div>
          <div class="col-md-4 mb-3">
            <label class="sr-only">Card number last 4 digits</label>
            <input
              v-model="bookingSearch.lastFourCardDigits"
              :disabled="searchInProgress"
              :class="{ 'is-invalid': $v.bookingSearch.lastFourCardDigits.$invalid}"
              type="text"
              class="form-control"
              placeholder="Card No. last 4 digits"
            >
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="sr-only">Entry Date</label>
            <div class="">
              <mag-datepicker-single
                :block="true"
                placeholder="Entry Date"
                :show-clear-date="true"
                :disabled="searchInProgress"
                @date-changed="entryDateChange"
              />
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="sr-only">Exit Date</label>
            <div class="input-wrapper">
              <mag-datepicker-single
                :block="true"
                placeholder="Exit Date"
                :show-clear-date="true"
                :disabled="searchInProgress"
                @date-changed="exitDateChange"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div
            id="select-date-time"
            class="col-md-12"
          >
            <div class="row">
              <div class="col-6">
                <label>Booking Creation Date (from)</label>
                <div class="input-wrapper">
                  <mag-datepicker-single
                    :show-clear-date="true"
                    :block="true"
                    placeholder="Exit Date"
                    :initial-start-date="bookingSearch.startDate"
                    @date-changed="startDateChange"
                  />
                </div>
              </div>
              <div class="col-6">
                <label>Booking Creation Date (to)</label>
                <div class="input-wrapper">
                  <mag-datepicker-single
                    :block="true"
                    placeholder="Exit Date"
                    :initial-start-date="bookingSearch.endDate"
                    :show-clear-date="true"
                    @date-changed="endDateChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 mb-3">
          <button
            class="btn btn-secondary"
            type="button"
            @click="clear"
          >
            Clear
          </button>
          <button
            :disabled="$v.bookingSearch.$invalid || searchInProgress"
            class="btn btn-primary"
            type="button"
            @click="search"
          >
            Search
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { helpers, email, minLength } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import SelectAirport from '../SelectAirport'

const moment = require('moment')

export default {
    name: 'BookingSearch',
    components: {
        SelectAirport
    },
    data () {
        return {
            bookingSearch: {
                airport: 0,
                bookingReference: null,
                thirdPartyBookingReference: null,
                registration: null,
                surname: null,
                email: null,
                postcode: null,
                startDate: moment().subtract(12, 'months').toDate(),
                endDate: moment().add(1, 'days').toDate(),
                entryDate: null,
                exitDate: null,
                lastFourCardDigits: null
            },
            commonDatePickerOptions: {
                typeable: false,
                format: 'dd/MM/yyyy'
            },
            startDatePickerOptions: {
                highlighted: {
                    dates: [ new Date(moment()) ]
                },
                disabled: {
                    from: new Date(moment())
                }
            },
            endDatePickerOptions: {
                highlighted: {
                    dates: [ new Date(moment()) ]
                },
                disabled: {
                    from: new Date(moment().add(1, 'days'))
                }
            },
            searchInProgress: false
        }
    },
    computed: {
        ...mapState({
            airports: state => state.airport.airports,
            bookings: state => state.booking.bookingResults,
            searchParams: state => state.booking.searchParams
        }),
        selectedAirportId: {
            get () {
                return this.$store.state.airport.selectedAirportId
            },
            async set (value) {
                await this.$store.dispatch('setSelectedAirportId', parseInt(value))
            }
        }
    },
    async created () {
        this.clear()
        await this.$store.dispatch('getAirports')
        for (let i = 0; i < this.airports.length; i++) {
            this.$store.dispatch('getConfiguration', {
                section: 'AirportConfigurations',
                identifier: this.airports[i].id
            })
        }

        if (this.searchParams !== null) { this.bookingSearch = _.cloneDeep(this.searchParams) }
    },
    mounted () {
        this.$store.dispatch('getConfiguration', {
            section: 'CultureSettings',
            identifier: 'LanguageCode'
        }).then(() => {
            var locale = this.$store.getters['getSpecificConfiguration']({
                section: 'CultureSettings',
                identifier: 'LanguageCode'
            })

            moment.locale(locale.languageCode.toLowerCase())
        })
    },
    validations: {
        bookingSearch: {
            email: {
                email
            },
            lastFourCardDigits: {
                minLength: minLength(4)
            }
        }
    },
    methods: {
        entryDateChange (date) {
            this.bookingSearch.entryDate = date
        },
        exitDateChange (date) {
            this.bookingSearch.exitDate = date
        },
        startDateChange (date) {
            this.bookingSearch.startDate = date
        },
        endDateChange (date) {
            this.bookingSearch.endDate = date
        },
        async search () {
            this.searchInProgress = true
            await this.$store.dispatch('clearBookings')
            this.bookingSearch.airport = this.selectedAirportId
            if (!helpers.req(this.bookingSearch.bookingReference) &&
                !helpers.req(this.bookingSearch.thirdPartyBookingReference) &&
                !helpers.req(this.bookingSearch.vehicleRegistration) &&
                !helpers.req(this.bookingSearch.lastName) &&
                !helpers.req(this.bookingSearch.email) &&
                !helpers.req(this.bookingSearch.postcode) &&
                !helpers.req(this.bookingSearch.entryDate) &&
                !helpers.req(this.bookingSearch.exitDate) &&
                !helpers.req(this.bookingSearch.lastFourCardDigits)) {
                this.$toasted.error('You must input at least one search term')
            } else {
                await this.$store.dispatch('updateSearchParams', _.cloneDeep(this.bookingSearch))

                this.bookingSearch.startDate = new Date(moment(this.bookingSearch.startDate).startOf('day'))
                this.bookingSearch.endDate = new Date(moment(this.bookingSearch.endDate).startOf('day'))

                if (this.bookingSearch.entryDate) {
                    this.bookingSearch.entryDate = moment(this.bookingSearch.entryDate).toDate()
                }

                if (this.bookingSearch.exitDate) {
                    this.bookingSearch.exitDate = moment(this.bookingSearch.exitDate).toDate()
                }

                var result = await this.$store.dispatch('bookingSearch', this.bookingSearch)
                console.log('result.status = ', result.status)
                if (result.status === 200 || result.status === 204) {
                    if (this.bookings.length < 1) {
                        this.$toasted.error('No bookings found')
                    } else {
                        this.$scrollTo('#search_results', 2000)
                    }
                } else {
                    this.$toasted.error('Error searching for bookings.')
                }
            }
            this.searchInProgress = false
        },
        async clear () {
            await this.$store.dispatch('updateSearchParams', null)
            await this.$store.dispatch('clearBookings')
            this.resetBookingSearch()
        },
        resetBookingSearch () {
            this.selectedAirportId = 0
            this.bookingSearch = {
                airport: 0,
                bookingReference: null,
                registration: null,
                surname: null,
                email: null,
                postcode: null,
                startDate: new Date(moment().subtract(12, 'months')),
                endDate: new Date(moment().add(1, 'days')),
                entryDate: null,
                exitDate: null,
                lastFourCardDigits: null
            }
        }
    }
}
</script>
<style lang="scss">
    .DateInput {
        padding: 0px;
        .DateInput_input {
            line-height: 15px;
            font-size: 14px;
            font-weight: normal;
            padding: 10px 11px 9px;
        }
    }
</style>
